import wx from 'weixin-js-sdk'
import { getWxInfo } from '@/api/user.js'

// 是否微信环境
export const isWeiXin = () => /MicroMessenger/i.test(navigator.userAgent.toLowerCase())

// JSSDK 签名 url：取当前页面地址（不含 hash）；
// iOS 微信内 SPA 路由切换后签名会失效，需用首次进入的地址（登录页已存 sessionStorage）
const getSignUrl = () => {
  const isIOS = /\(i[^;]+;( U;)? CPU.+Mac OS X/.test(navigator.userAgent)
  const originUrl = sessionStorage.getItem('originUrl')
  const url = isIOS && originUrl ? originUrl : window.location.href
  return url.split('#')[0]
}

let wxReadyPromise = null

/**
 * 注入微信 JSSDK 配置（仅微信环境执行）
 * @returns {Promise<boolean>} wx.ready 后 resolve
 */
export const wxConfig = () => {
  if (!isWeiXin()) {
    return Promise.resolve(false)
  }
  if (!wxReadyPromise) {
    wxReadyPromise = (async () => {
      const res = await getWxInfo({ url: getSignUrl() })
      if (res.resultCode != 0) {
        throw new Error(res.resultDesc || '获取微信签名失败')
      }
      const wxData = res.data
      wx.config({
        beta: true,
        debug: false,
        appId: wxData.appid, // 必填，公众号的唯一标识
        timestamp: wxData.timestamp, // 必填，生成签名的时间戳
        nonceStr: wxData.nonceStr, // 必填，生成签名的随机串
        signature: wxData.signature, // 必填，签名
        jsApiList: [
          "checkJsApi",
          "chooseWXPay",
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
          "updateTimelineShareData",
          "updateAppMessageShareData",
          "previewImage",
          "getBrandWCPayRequest",
        ],
      })
      return new Promise((resolve, reject) => {
        wx.ready(() => resolve(true))
        wx.error((err) => {
          wxReadyPromise = null // 签名失败允许重试
          reject(err)
        })
      })
    })()
  }
  return wxReadyPromise
}

/**
 * 发起微信支付
 * @param {object} data 后端下单返回的支付参数（appId/timeStamp/nonceStr/packageVal/signType/paySign）
 * @returns {Promise} 支付成功 resolve，取消或失败 reject
 */
export const wxPay = (data) => {
  return new Promise((resolve, reject) => {
    wx.chooseWXPay({
      appId: data.appId,
      timestamp: data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
      nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
      package: data.packageVal, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
      signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
      paySign: data.paySign, // 支付签名
      success(res) {
        // 前端判断返回方式，微信团队郑重提示：不保证绝对可靠，切记！
        if (res.errMsg == "chooseWXPay:ok") {
          resolve(res)
        } else {
          reject(res)
        }
      },
      fail: reject,
      cancel: reject,
    })
  })
}
